export const UPCOMING_EVENTS_DATA_ID = 'home_upcoming-events';
export const UPCOMING_EVENTS_MAX_CARD = 3;
export const UPCOMING_EVENTS_DESK_MAX_LINES = 3;
export const UPCOMING_EVENTS_MOBILE_MAX_LINES = 2;
export const UPCOMING_EVENTS_TWO_CARDS = 2;
export const UPCOMING_EVENTS_ONE_CARDS = 1;
export var LogoIconSize;
(function (LogoIconSize) {
    LogoIconSize["SMALL"] = "32px";
    LogoIconSize["MEDIUM"] = "64px";
    LogoIconSize["LARGE"] = "96px";
})(LogoIconSize || (LogoIconSize = {}));
export var EventCardLength;
(function (EventCardLength) {
    EventCardLength[EventCardLength["MAX_CARD"] = UPCOMING_EVENTS_MAX_CARD] = "MAX_CARD";
    EventCardLength[EventCardLength["TWO_CARDS"] = UPCOMING_EVENTS_TWO_CARDS] = "TWO_CARDS";
    EventCardLength[EventCardLength["ONE_CARD"] = UPCOMING_EVENTS_ONE_CARDS] = "ONE_CARD";
})(EventCardLength || (EventCardLength = {}));
export const infiniteDesktopSizeMap = {
    [EventCardLength.MAX_CARD]: LogoIconSize.SMALL,
    [EventCardLength.TWO_CARDS]: LogoIconSize.MEDIUM,
    [EventCardLength.ONE_CARD]: LogoIconSize.LARGE,
};
export const tabletSizeMap = {
    [EventCardLength.MAX_CARD]: LogoIconSize.SMALL,
    [EventCardLength.TWO_CARDS]: LogoIconSize.SMALL,
    [EventCardLength.ONE_CARD]: LogoIconSize.MEDIUM,
};
